import { render, staticRenderFns } from "./BundlePage.vue?vue&type=template&id=53ea2dac&scoped=true&"
import script from "./BundlePage.vue?vue&type=script&lang=js&"
export * from "./BundlePage.vue?vue&type=script&lang=js&"
import style0 from "./BundlePage.vue?vue&type=style&index=0&id=53ea2dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea2dac",
  null
  
)

export default component.exports